import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Method } from './components/Method';
import { Contents } from './components/Contents';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2rit3h6j5vwqy">
      <Hero data-id="element-1" data-mp="2mn5f2tci77mi" />
      <main data-id="element-2" data-mp="2mnng03a42a0r">
        <Problem data-id="element-3" data-mp="2mjpyfm36lqiz" />
        <Method data-id="element-4" data-mp="31aqh0jxn70su" />
        <Contents data-id="element-5" data-mp="31b8gdpflpv4z" />
        <Author data-id="element-6" data-mp="31brz38d2snk2" />
        <Testimonials data-id="element-7" data-mp="31c9ygdv1bhw7" />
        <Offer data-id="element-8" data-mp="31cjo20c63n1d" />
        <Faq data-id="element-9" data-mp="2wka0us2ft12s" />
      </main>
      <LegalFooter data-id="element-10" data-mp="2wjqkvgwckmre" />
    </div>;
}